import Url from "./Api";
import axios from 'axios';
import Swal from 'sweetalert2';

const authAxios = axios.create({
  baseURL: Url
});

// Agregamos el token dinámicamente a cada petición
authAxios.interceptors.request.use(config => {
  const token = localStorage.getItem('jwtto');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

authAxios.interceptors.response.use(
  response => {
    // Si el backend devuelve un 200 pero dice que expiró (comportamiento legacy de algunos backends)
    if (response.data && response.data.status === 'Token is Expired') {
       return Promise.reject({ response: { status: 401, data: response.data } });
    }
    return response;
  },
  async error => {
    const originalRequest = error.config;

    // Si recibimos 401 y no hemos intentado refrescar
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        
        if (isRefreshing) {
            // Si ya estamos refrescando, añadimos la petición a la cola
            return new Promise(function(resolve, reject) {
                failedQueue.push({resolve, reject})
            }).then(token => {
                originalRequest.headers['Authorization'] = 'Bearer ' + token;
                return authAxios(originalRequest);
            }).catch(err => {
                return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
            const token = localStorage.getItem('jwtto');
            // Llamar al endpoint de refresh
            const res = await axios.post(Url + '/auth/refresh', {}, {
                headers: { 'Authorization': 'Bearer ' + token }
            });

            if (res.data && res.data.access_token) {
                const newToken = res.data.access_token;
                localStorage.setItem('jwtto', newToken);
                
                authAxios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
                originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
                
                processQueue(null, newToken);
                
                return authAxios(originalRequest); // Reintentar la petición original
            }
        } catch (refreshError) {
            // Si falla el refresh, el token realmente está vencido de forma definitiva
            processQueue(refreshError, null);
            localStorage.removeItem('jwtto');
            localStorage.removeItem('idusuario');
            window.location.href = '/login';
            return Promise.reject(refreshError);
        } finally {
            isRefreshing = false;
        }
    }

    // Casos graves y específicos
    if (error.response && error.response.status === 500 && error.response.data && error.response.data.message && error.response.data.message.includes('id_rol')) {
        localStorage.removeItem('jwtto');
        localStorage.removeItem('idusuario');
        window.location.href = '/login';
        return Promise.reject(new Error('Token is Expired or Session ended'));
    }

    // Mostrar alertas para otros errores (ignorando el 401 porque ya lo tratamos o deslogueamos)
    if (error.response && error.response.status !== 401) {
      console.error('Error en la respuesta:', error.response);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Error: ' + error.response.status + ' - ' + (error.response.data.message || 'Ocurrió un error'),
      });
    } else if (error.request && !error.response) {
      console.error('Error en la solicitud:', error.request);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No se recibió respuesta del servidor. Por favor, intenta de nuevo más tarde.',
      });
    }

    return Promise.reject(error);
  }
);

export default authAxios;